<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        applyStateOptions: [],
        applyVehicleClassOptions: [],
        form: [
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // 邀请车队
            label: '邀请车队',
            value: 'tenantName',
            type: 'input',
            placeholder: '请输入邀请车队',
          },
          { // 车队手机
            label: '车队手机',
            value: 'linkPhone',
            type: 'input',
            placeholder: '请输入车队手机',
          },
          { // 申请类型
            label: '申请类型',
            value: 'applyVehicleClass',
            type: 'select',
            default: -1,
            placeholder: '请选择申请类型',
          },
          { // 申请状态
            label: '申请状态',
            value: 'applyState',
            type: 'select',
            default: -1,
            placeholder: '请选择申请状态',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      searchBoxData.recordType = 1;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'APPLY_STATE,VEHICLE_CLASS',
    });
    const safeEnum = (index) => (Array.isArray(enumsList) && Array.isArray(enumsList[index])) ? enumsList[index] : [];
    this.searchBoxData.applyStateOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...safeEnum(0),
    ];
    this.searchBoxData.applyVehicleClassOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...safeEnum(1),
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
